import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { Route as ReactRoute } from 'react-router';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    _hsq: { push: (callParam: any) => void };
    hsConversationsSettings: any;
  }
}

function Route({ component: Component, ...children }: any): JSX.Element {
  const user = useSelector((state: any) => state.user);
  const location = useLocation();

  useEffect(() => {
    if (user.id !== 0) {
      try {
        window._hsq.push(['setPath', location.pathname]);
        window._hsq.push(['trackPageView']);
      } catch (error) {
        console.error('hsq route', error);
      }
    }
  }, [location]);

  return (
    <ReactRoute {...children} render={(props) => <Component {...props} />} />
  );
}

export default Route;
